import React from "react";
import NavigationAlt from "../NavigationAlt";
import { MDBContainer } from "mdb-react-ui-kit";

const InPageHeaderShapesAltNav = (props) => {
  const hasHeading = props.pageHeading?.trim();
  const hasSubHeading = props.pageSubHeading?.trim();

  return (
    <div>
      <header
        className="inpage-header-shapes-alt-nav component"
        style={{
          width: "100%",
          marginBottom: "4rem",
          backgroundImage: `url(${props.inPageBGImage})`
        }}
      >
        <MDBContainer fluid className="inpage-header-shapes">
          <div className="hold-inpage-headeralt-text">
            
            {hasHeading ? (
              <h1 className="internalPageText heading">
                {props.pageHeading}
              </h1>
            ) : hasSubHeading ? (
              // fallback: ensure at least one meaningful heading exists
              <h1 className="internalPageText heading">
                {props.pageSubHeading}
              </h1>
            ) : null}

            {hasHeading && hasSubHeading && (
              <h2 className="internalPageText subheading">
                {props.pageSubHeading}
              </h2>
            )}

          </div>

          {props.optionalComponent && (
            <div className="optionalImage">
              {props.optionalComponent}
            </div>
          )}
        </MDBContainer>
      </header>
    </div>
  );
};

export default InPageHeaderShapesAltNav;